import React from "react";
import styled from "../style.module.css";

// Compact multi-column leaderboard. `columns` = [{ key, label, render? , align? }].
const LeaderboardTable = ({ title, rows, columns, emptyHint, asOf = true }) => {
  const data = rows || [];
  return (
    <div className={styled.chartCard}>
      <div className={styled.chartCardHead}>
        <h3 className={styled.chartTitle}>{title}</h3>
        {asOf && <span className={styled.asOfTag}>Live</span>}
      </div>
      {data.length > 0 ? (
        <div className={styled.lbWrap}>
          <table className={styled.lbTable}>
            <thead>
              <tr>
                <th className={styled.lbRankCol}>#</th>
                {columns.map((c) => (
                  <th key={c.key} className={c.align === "right" ? styled.lbRight : undefined}>
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((r, i) => (
                <tr key={i}>
                  <td className={styled.lbRank}>{i + 1}</td>
                  {columns.map((c) => (
                    <td key={c.key} className={c.align === "right" ? styled.lbRight : undefined}>
                      {c.render ? c.render(r[c.key], r) : r[c.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className={styled.emptyHint}>{emptyHint || "No data yet."}</p>
      )}
    </div>
  );
};

export default LeaderboardTable;
